import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Ariakit from '@ariakit/react';
import { forwardRef } from 'react';
import { Drawer } from './Drawer';
import { Modal } from './Modal';
import * as Styles from './styles';
const DialogDismiss = forwardRef(function DialogDismiss({ 'aria-label': ariaLabel, className, render = (_jsx(Dialog.CloseIconButton, { className: className, "aria-label": ariaLabel ?? 'Close dialog' })), ...rest }, ref) {
    return _jsx(Styles.Dismiss, { render: render, "aria-label": ariaLabel, ...rest, ref: ref });
});
const DialogCloseIconButton = forwardRef(function DialogCloseIconButton(props, ref) {
    return (_jsx(Styles.CloseIconButton, { ...props, ref: ref, children: _jsx(Styles.CloseIcon, { width: '16px', height: '16px' }) }));
});
const DialogTitle = forwardRef(function DialogTitle({ align, ...rest }, ref) {
    return _jsx(Styles.Title, { "$align": align, ...rest, ref: ref });
});
export const DialogHeader = forwardRef(function DialogHeader({ borderless = false, reverse = false, dismiss = _jsx(Dialog.Dismiss, { "aria-label": 'Close dialog' }), title, ...rest }, ref) {
    return (_jsxs(Styles.Header, { "$reverse": reverse, "$borderless": borderless, ...rest, ref: ref, children: [title, dismiss] }));
});
export const DialogFooter = forwardRef(function DialogFooter({ children, ...rest }, ref) {
    return (_jsx(Styles.Footer, { ...rest, ref: ref, children: children }));
});
function useDialogState() {
    const dialogCtx = Ariakit.useDialogContext();
    if (!dialogCtx) {
        throw new Error('You must use `useDialogState` within a `Dialog.Provider`.');
    }
    const dialogState = Ariakit.useStoreState(dialogCtx);
    return { ...dialogState, ...dialogCtx };
}
export const Dialog = {
    Provider: Ariakit.DialogProvider,
    Disclosure: Ariakit.DialogDisclosure,
    Dismiss: DialogDismiss,
    CloseIconButton: DialogCloseIconButton,
    Header: DialogHeader,
    Content: Styles.Content,
    Title: DialogTitle,
    Footer: DialogFooter,
    Backdrop: Styles.Backdrop,
    Modal: Modal,
    Drawer: Drawer,
    useState: useDialogState,
};
//# sourceMappingURL=index.js.map